/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_UnavailableInputs */



/**
* | output |
* | --- |
* | "This file is no longer available at its original location." |
*
* @param {Embedding_Error_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_unavailable = /** @type {((inputs?: Embedding_Error_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Datei ist an ihrem ursprünglichen Ort nicht mehr verfügbar.")
	return /** @type {LocalizedString} */ ("This file is no longer available at its original location.")
});